export * from './nav-tabs.component';
